import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import { PureButton, PureLink } from '../../basics';
import { RenderType } from '../../enums';
import styles from './ToggleButton.module.scss';
const ToggleButton = forwardRef(({ a11yText, as, children, className, isSelected = false, ...restProps }, componentRef) => {
    const classNameList = classNames(className, 'd-inline-block text-decoration-none', styles.toggleButton, {
        [styles.isSelected]: isSelected,
    });
    if (as === RenderType.Button) {
        return (_jsxs(PureButton, { className: classNameList, ref: componentRef, ...restProps, children: [_jsx("span", { className: "screenReaderOnly", children: a11yText }), children] }));
    }
    return (_jsxs(PureLink, { className: classNameList, ...restProps, children: [_jsx("span", { className: "screenReaderOnly", children: a11yText }), children] }));
});
ToggleButton.displayName = ToggleButton.name;
export { ToggleButton };
